import img from "../../assets/mail.png";
import img1 from "../../assets/github (1).png";
import img2 from "../../assets/linkedin (1).png";
export const SocialData = [
  {
    platform: "LinkedIn",
    link: "https://www.linkedin.com/in/parul-gupta-3688a019a/",
    icon: img2,
  },
  {
    platform: "Mail",
    link: "mailto:parulgupta262626@gmail.com",
    icon: img,
  },
  {
    platform: "GitHub",
    link: "https://github.com/iparul",
    icon: img1,
  },
];
